import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { UiStorageKey } from 'mbs-ui-shared@models';
import { UiStorageService } from 'mbs-ui-shared@services';
import { ApplicationStoreActions, ApplicationStoreSelectors } from 'mbs-ui-shared@store/application';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ApplicationStateFacade {
  public selectStorage$ = this.store.select(ApplicationStoreSelectors.selectStorage);
  public selectStorageLoaded$ = this.store.select(ApplicationStoreSelectors.selectStorageLoaded);
  public selectStorageLoading$ = this.store.select(ApplicationStoreSelectors.selectStorageLoading);
  public selectStorageWhenLoaded$ = this.selectStorageLoaded$.pipe(
    filter(Boolean),
    switchMap(() => this.selectStorage$)
  );
  public selectFooterExist$ = this.store.select(ApplicationStoreSelectors.selectFooterExist);

  constructor(private store: Store, private uiStorage: UiStorageService) {}

  getUiStorage(): Observable<{ [key: string]: any }> {
    this.loadUiStorage();

    return this.selectStorageWhenLoaded$;
  }

  loadUiStorage(force = false): void {
    this.store.dispatch(ApplicationStoreActions.loadStorage({ force }));
  }

  setFooterExist(payload: boolean): void {
    this.store.dispatch(ApplicationStoreActions.setFooterExist({ payload }));
  }

  updateStorageSetting(key: UiStorageKey, value: any, addAuditLogRecord = false): Observable<null> {
    return this.uiStorage
      .storeSetting(key, value, addAuditLogRecord)
      .pipe(tap(() => this.store.dispatch(ApplicationStoreActions.setStorageSetting({ payload: { key, value } }))));
  }

  deleteStorageItem(key: UiStorageKey): Observable<null> {
    return this.uiStorage.deleteSetting(key);
  }
}
